<template>
  <div class>
    <button class="btn_default" @click.prevent="show">
      Byt lösenord
    </button>
    <modal name="modal-changepassword" :adaptive="true" height="auto" :scrollable="true" :width="450" @opened="opened">
      <div class="px-5 py-5">
        <h2 class="mb-4 text-xl tracking-wide">BYT LÖSENORD - {{ current.userName}}</h2>

        <ValidationObserver ref="form" v-slot="{ invalid }">
          <form @submit.prevent="onCreate()">
            <ValidationProvider v-slot="{ errors }" name="Lösenord" rules="required">
              <span class="text-gray-700">Lösenord</span>
              <input v-model="changePasswordDto.password" type="password" class="w-full mt-1 form-input" :class="{
                  'border-red-600 focus:border-red-600': errors[0]
                }" />
              <span class="block mt-1 text-sm text-red-500">{{
                errors[0]
              }}</span>
            </ValidationProvider>

            <div class="flex justify-end mt-10 mb-1">
              <button type="submit" class="block btn_blue" :class="{ 'opacity-50': invalid }" :disabled="invalid">Spara</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { UsersService } from "@/services/api-service";

export default {
  data() {
    return {
      changePasswordDto: {
        subject: "",
        password: ""
      }
    };
  },

  computed: {
    ...mapGetters("usersStore", ["current"])
  },
  methods: {
    show() {
      this.changePasswordDto.subject = this.current.subject;
      this.$modal.show("modal-changepassword");
    },
    async onCreate() {
      await UsersService.changePassword(this.changePasswordDto);
      this.$modal.hide("modal-changepassword");
    }
  }
};
</script>
